import gsap from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import Swiper from 'swiper/bundle';

import {initlocalLazyScrollAutoplay} from '../video';

import { scaleBlockToScreen } from '../../helpers/video-helpers';
import { CLASSES, IS_HOME_VERTICAL, IS_PHONE } from '../../helpers/consts';
import { getInitedVideoPlayer } from '../video';

import accordeon from '../../helpers/accordeon';
import refreshScrollAndTriggers from '../../helpers/refreshScrollTriggers';

import { calculateCathetus } from '../social-slider-section';

gsap.registerPlugin(ScrollTrigger);

export default () => {
	const modals = document.querySelectorAll('.js-service-modal');
	let slider = null;
	let socialReelsInited = false;
	let socialReelsTl = null;
	const videoPlayers = new Array(modals.length).fill(null);

	const playVideo = (modal, i) => {
		if(videoPlayers[i]) {
			videoPlayers[i].play();
		}
		else {
			const blockClass = IS_PHONE ? 'js-accord-video-screen' : 'js-service-modal';
			const wrapper = modal.querySelector(`.${blockClass} .js-video-wrapper`);
			const videoBlock = modal.querySelector(`.${blockClass} .js-modal-video`);
			const video = modal.querySelector(`.${blockClass} video`);

			if(!videoBlock || !video) return;

			const contronls = IS_PHONE ? ['play', 'progress', 'volume', ] : [];
			// ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'airplay', 'fullscreen']

			const videoPlayer = getInitedVideoPlayer(video, {
				ratio: '16:9',
				muted: true,
				autoplay: false,
				controls: contronls,
				vimeo: {
					background: true,
					transparency: true,
					autoplay: false,
					muted: true,
				}
			});
			videoPlayer.on('ready', () => {
				videoPlayer.volume = 0;
				videoPlayer.play();
			});
			videoPlayer.on('play', () => {
				setTimeout(() => {
					wrapper.classList.add(CLASSES.mediaLoaded);
				}, 400);
			});

			if(!IS_PHONE) {
				scaleBlockToScreen(videoBlock);

				const volumeBtn = modal.querySelector('.js-modal-media-volume-btn');
				if(volumeBtn) {
					volumeBtn.addEventListener('click', (e) => {
						e.preventDefault();
						if(!videoPlayer) return;

						if(videoPlayer.muted) {
							videoPlayer.muted = false;
							videoPlayer.volume = 1;
						}
						else {
							videoPlayer.muted = true;
							videoPlayer.volume = 0;
						}
					});
				}
			}

			videoPlayers[i] = videoPlayer;
		}
	};

	const pauseVideo = () => {

		videoPlayers.forEach((player) => {
			if(player) {
				player.muted = true;
				player.volume = 0;
				player.restart();
				player.pause();
			}
		});
	};

	const playSlider = (modal) => {
		const sliderClass = IS_PHONE ? 'js-service-accord-slider' : 'js-service-modal-slider';
		const sliderEl = modal.querySelector(`.${sliderClass}`);
		if(!sliderEl || slider) return;

		slider = new Swiper(sliderEl, {
			autoplay: true,
			slidesPerView: 1,
			effect: 'fade',
			speed: 600,
			loop: true,
			allowTouchMove: false,
			autoHeight: false,
		});
	};

	const initReels = (modal) => {
		if (socialReelsInited) return;

		socialReelsInited = true;
		const wrapper = modal.querySelector('.js-modal-reels-screen');
		const scrollBlock = modal.querySelector('.js-modal-reels-screen-inner');
		const scrollBlockInner = modal.querySelector('.js-modal-reels-screen-scroll-wrapper');

		// Ensure GSAP styles are saved
		ScrollTrigger.saveStyles(scrollBlockInner);

		// Duplicate the list to create an infinite effect
		const originalItems = [...scrollBlockInner.children];
		originalItems.forEach((item) => {
			const clone = item.cloneNode(true);
			scrollBlockInner.appendChild(clone);
		});


		// Re-select all videos, including newly duplicated ones
		let mediaVideos = [...wrapper.querySelectorAll('.js-modal-social-video')];

		initlocalLazyScrollAutoplay(mediaVideos, {
			ratio: '9:16',
			muted: true,
			controls: [],
			autoplay: false,
		});

		// Get the full height of the scrolling content (original + duplicate)
		const totalHeight = scrollBlockInner.scrollHeight / 2;

		// GSAP Infinite Scroll Animation
		socialReelsTl = gsap.to(scrollBlockInner, {
			y: `-${totalHeight}px`, // Move up by the total height
			duration: 10, // Adjust speed as needed
			ease: "linear",
			repeat: -1,
			onUpdate: function () {
				// Reset position when it reaches the halfway point
				if (Math.abs(parseFloat(this.targets()[0].style.transform.split(',')[1])) >= totalHeight) {
					gsap.set(scrollBlockInner, { y: 0 });
				}
			}
		});
	};

	const playReels = () => {
		if(socialReelsInited && socialReelsTl) {
			socialReelsTl.play();
		}
	};
	const pauseReels = () => {
		if(socialReelsInited && socialReelsTl) {
			socialReelsTl.pause();
		}
	};

	const isModalHasVideo = (modal) => {
		return !!modal.querySelector('.js-modal-video');
	}
	const changeModal = (modal, activeModalType, activeModalIndex) => {
		pauseVideo();
		pauseReels();
		// pause reels)
		if (activeModalType === 'brand') {
			const isVideo = isModalHasVideo(modal);

			if(isVideo) {
				playVideo(modal, activeModalIndex);
			}
			else {
				playSlider(modal);
			}
		}
		else if (activeModalType === 'social') {
			playReels(modal);
		}
		else {
			playVideo(modal, activeModalIndex);
		}
	};
	const closeModal = (modalType) => {
		if (modalType === 'brand') {
			pauseVideo();
		}
		else if (modalType === 'social') {
			pauseReels();
		} {
			pauseVideo();
		}
	};

	if(IS_PHONE) {

		const accordItems = [...document.querySelectorAll('.js-card-accord-item')];
		const socialAccord = document.querySelector('.js-card-accord-item[data-type="social"]');
		accordeon({
			needCloseOther: false,
			duration: 0.5,
			ease: 'power1.out',
			delay: 0,
			onStart: () => {},
			onComplete: (el) => {
				const isOpen = el.classList.contains(CLASSES.open);
				const index = accordItems.indexOf(el);
				const accordType = el.dataset.type;

				if(isOpen) {
					changeModal(el, accordType, index);
				}
				else {
					closeModal(accordType);
				}
				refreshScrollAndTriggers();
			}
		});

		initReels(socialAccord);
		return;
	}

	const brandSliderGlobalOpenClass = 'is-brand-slider-modal-global-open';
	const brandVideoGlobalOpenClass = 'is-brand-video-modal-global-open';
	const socialGlobalOpenClass = 'is-social-modal-global-open';
	const productionGlobalOpenClass = 'is-production-modal-global-open';

	const removeGlobalModalClasses = () => {
		document.body.classList.remove(brandSliderGlobalOpenClass);
		document.body.classList.remove(brandVideoGlobalOpenClass);
		document.body.classList.remove(socialGlobalOpenClass);
		document.body.classList.remove(productionGlobalOpenClass);
	}
	const changeGlobalModalClasses = (modal, modalType) => {
		removeGlobalModalClasses();
		if (modalType === 'brand') {
			const isVideo = isModalHasVideo(modal);
			if(isVideo) {
				document.body.classList.add(brandVideoGlobalOpenClass);
			} else {
				document.body.classList.add(brandSliderGlobalOpenClass);
			}
		}
		else if (modalType === 'social') {
			document.body.classList.add(socialGlobalOpenClass);
		}
		else if (modalType === 'production') {
			document.body.classList.add(productionGlobalOpenClass);
		}
	}

	const headerCloseBtn = document.querySelector('.js-header-close-home-modal-btn');
	if(headerCloseBtn) {
		headerCloseBtn.addEventListener('click', (e) => {
			e.preventDefault();
			removeGlobalModalClasses();
			pauseVideo();
			pauseReels();
			pauseVideo();
			document.body.classList.remove(CLASSES.menuOpen);

			modals.forEach((modal) => {
				modal.classList.remove(CLASSES.active);
				setTimeout(() => {
					modal.classList.add(CLASSES.disabled);
				}, 400)
			});

		});
	}

	modals.forEach((modal, index) => {

		const modalType = modal.dataset.modal;
		const openBtn = document.querySelector(`.js-service-modal-btn[data-modal="${modalType}"]`);
		const closeBtn = modal.querySelector('.js-service-modal-close-btn');
		const nextBtn = modal.querySelector('.js-service-modal-next-btn');

		if (modalType === 'social') {
			initReels(modal);
		}

		openBtn.addEventListener('click', (e) => {
			e.preventDefault();
			modal.classList.remove(CLASSES.disabled);
			modal.classList.add(CLASSES.active);
			changeModal(modal, modalType, index);
			changeGlobalModalClasses(modal, modalType);
		});

		closeBtn.addEventListener('click', (e) => {
			e.preventDefault();
			modal.classList.remove(CLASSES.active);
			removeGlobalModalClasses();

			closeModal(modalType);

			modal.addEventListener('transitionend', () => {
				modal.classList.add(CLASSES.disabled);
			}, { once: true });
		});

		if(nextBtn) {
			nextBtn.addEventListener('click', (e) => {
				e.preventDefault();
				let nextModalType = null;

				if (modalType === 'brand') {
					nextModalType = 'social';
				}
				else if (modalType === 'social') {
					nextModalType = 'production';
				}

				if(!nextModalType) return;

				const nextModal = document.querySelector(`.js-service-modal[data-modal="${nextModalType}"]`);
				modal.classList.remove(CLASSES.active);
				nextModal.classList.remove(CLASSES.disabled);
				nextModal.classList.add(CLASSES.active);
				setTimeout(() => {
					modal.classList.add(CLASSES.disabled);
				}, 300)
				changeModal(nextModal, nextModalType, index + 1);
				changeGlobalModalClasses(nextModal, nextModalType);
			});
		}
	});

};
